import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * URLNormalizer component handles client-side URL normalization:
 * - Removes trailing slashes (except root)
 * - Preserves query parameters for functionality (e.g., ?lang=)
 * - Ensures consistent URL structure for SEO
 */
export function URLNormalizer() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { pathname, search, hash } = location;
    
    // Normalize trailing slash (remove it, except for root)
    if (pathname !== '/' && pathname.endsWith('/')) {
      const normalizedPath = pathname.slice(0, -1);
      // Replace (not push) to avoid creating history entries
      navigate(normalizedPath + search + hash, { replace: true });
    }
  }, [location, navigate]);

  return null;
}
